// extracted by mini-css-extract-plugin
export default {"root":"ToastNotification-module-root","body":"ToastNotification-module-body","message":"ToastNotification-module-message"};